import React from 'react';

export default function HumanCoach() {
  return (
    <>
      <h2>Congratulations on Your Progress!</h2>

      <p>
        Elevate Your Leadership Journey with Expert Coaching
      </p>
      <p>
        Based on your assessment and AI debrief, we’ve identified
        key opportunities where personalized coaching can accelerate your
        growth and amplify your leadership impact.
      </p>
      <h3>Take Your Leadership to the Next Level</h3>
      <p>
        With guidance from our certified LeggUP coaches, you will:
        <ul>
          <li>Craft advanced leadership strategies tailored to your unique strengths</li>
          <li>Navigate complex organizational dynamics with clarity and confidence</li>
          <li>Build sustainable leadership habits for lasting success</li>
          <li>Achieve breakthrough results in your priority development areas</li>
        </ul>
      </p>

    </>
  );
}
